import React from 'react';
import { Box, Typography, Tooltip } from '@mui/material';
import { Message as MessageIcon } from '@mui/icons-material';

export default function DocumentItem({ document, handleSetUrlDocument, itemStyle }) {
  const hasNotes = document?.notas && document.notas.length > 0;

  // Estilo común para las comillas resaltadas
  const quoteStyle = {
    fontSize: '2rem',
    fontWeight: 'bold',
    color: '#148f9f',
    lineHeight: 0,
    fontFamily: 'serif', // Las fuentes con serifa tienen comillas más bonitas
    display: 'inline-block',
    verticalAlign: 'middle',
  };

  return (
    <Tooltip
      title={
        hasNotes ? (
          <Box sx={{ p: 1, width: 380 }}>
            {/* Barra superior */}
            <Box
              sx={{
                height: 4,
                width: 60,
                backgroundColor: '#148f9f',
                borderRadius: 4,
                mb: 2
              }}
            />

            {/* Contenedor con scroll */}
            <Box
              sx={{
                display: 'block',
                maxHeight: 200,
                overflowY: 'auto',
                overflowX: 'hidden',
                pr: 1.5,
                '&::-webkit-scrollbar': { width: 6 },
                '&::-webkit-scrollbar-thumb': {
                  background: 'rgba(20, 143, 159, 0.4)',
                  borderRadius: 10
                },
                scrollbarWidth: 'thin',
                scrollbarColor: 'rgba(20, 143, 159, 0.4) transparent',
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
                <MessageIcon
                  sx={{
                    color: '#028b9d78',
                    fontSize: '1.2rem',
                    mt: 0.3,
                    flexShrink: 0
                  }}
                />

                <Typography
                  variant="body2"
                  sx={{
                    color: '#333333',
                    lineHeight: 1.7,
                    fontSize: '0.92rem',
                    fontWeight: 400,
                    textAlign: 'left',
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-word',
                    overflowWrap: 'anywhere',
                    textAlign: 'justify'
                  }}
                >
                  {/* Comilla de apertura */}
                  <Box component="span" sx={{ ...quoteStyle, mr: 0.5, mt: 1 }}>“</Box>
                  
                  {document.notas}
                  
                  {/* Comilla de cierre */}
                  <Box component="span" sx={{ ...quoteStyle, ml: 0.5, mt: 2 }}>”</Box>
                </Typography>
              </Box>
            </Box>
          </Box>
        ) : null
      }
      disableHoverListener={!hasNotes}
      arrow
      placement="right"
      enterDelay={350}
      componentsProps={{
        tooltip: {
          sx: {
            backgroundColor: '#fbfdfd',
            boxShadow: '0 10px 30px rgba(0,0,0,0.15)',
            border: '1px solid rgba(20, 143, 159, 0.2)',
            borderRadius: '12px',
            padding: '12px',
            maxWidth: 420,
            color: 'inherit',
            whiteSpace: 'normal',
            '& .MuiTooltip-arrow': {
              color: '#fbfdfd',
              '&::before': {
                border: '1px solid rgba(20, 143, 159, 0.2)'
              }
            }
          }
        }
      }}
    >
      <Box
        component="div"
        sx={{ ...itemStyle, cursor: 'pointer' }}
        onClick={() => handleSetUrlDocument(document)}
      >
        <Typography
          variant="subtitle1"
          sx={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            width: 300
          }}
        >
          {document.NombreMultimedia}
        </Typography>

        {hasNotes && (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography
              variant="body2"
              sx={{
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                width: 300,
                color: '#666666',
              }}
            >
              {document.notas}
            </Typography>

            <MessageIcon sx={{ color: '#028b9d78', ml: 0.5 }} />
          </Box>
        )}

        <Typography variant="caption">
          {document.Fecha}
        </Typography>
      </Box>
    </Tooltip>
  );
}